export const getTasks = state => state.tasks;

export const getStatusFilter = state => state.filters.status;
